import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img12 from "../../About/images/12.png";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person12 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img12} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Шарипова Салтанат Еркиновна
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        PhD (Системная инженерия), менеджер Центра компетенций и совершенства
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57884433800'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0001-7267-3261'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Astana IT University", менеджер Центра компетенций и совершенства
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Младший научный сотрудник. Создание базы данных основных стационарных источников загрязняющих веществ с регламентированием квот по эмиссии.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Более 5 лет занимается исследованиями в области машинного обучения. Сертифицированный проектный менеджер уровня C.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Разработанные системы и продукты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Система электронного документооборота
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Онлайн-сервис для автоматизации подбора и оценки кандидатов
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. Система оплаты по KPI
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    4. Система обслуживания студентов
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    5. Система поиска заимствований и цитат в учебных и научных работах
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    6. Система признания и нострификации дипломов
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    7. Система управления закупками в госсекторе
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Полученные охранные документы:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. №1712 (2013): Электронный курс по информационной безопасности
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. №7358 (2019): Электронный учебник "Компьютерное моделирование"
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. №3510 (2019): Курс "Промышленная безопасность"
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    4. №9823 (2020): Платформа OpenStudy.kz
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    5. №44682 (2024): Модель нейросети для прогноза влияния фосфора
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    6. №44683 (2024): Система прогнозирования влияния фосфора на урожайность
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - создание базы данных основных стационарных источников загрязняющих веществ с регламентированием квот по эмиссии
                </MyText>
            </Flex>
        </Flex>
    );
}